<div class="lum-c-rfq-details-kit-items">
  <mat-tab-group>
    <mat-tab label="Items">
      <table class="table table-striped">
        <thead>
          <tr>
            <th width="30%">SKU</th>
            <th class="text-right">Original Price</th>
            <th class="text-right">Quantity</th>
            <th>Unit</th>
            <th class="text-right">Price</th>
            <th class="text-right">Total</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let kitItem of kitItems; trackBy: trackById">
            <td>
              <a href="/inventory/{{ kitItem?.product?.id }}/view">
                [{{ kitItem?.product?.internal_sku }}]
                {{ kitItem?.product?.product_name }}
              </a>
            </td>
            <td class="text-right">
              {{ kitItem?.original_price | lumCurrency }}
            </td>
            <td class="text-right">
              {{ kitItem?.quantity | decimalPlaces }}
            </td>
            <td>
              {{ kitItem?.unit_of_measure?.name }}
            </td>
            <td class="text-right">
              {{ kitItem?.price | lumCurrency }}
            </td>
            <td class="text-right">
              {{ kitItem?.total | lumCurrency }}
            </td>
          </tr>
        </tbody>
      </table>
    </mat-tab>
    <mat-tab label="Warehouse Groups">
      <lum-rfq-kit-items-warehouse
        [kitItems]="kitItems"
      ></lum-rfq-kit-items-warehouse>
    </mat-tab>
  </mat-tab-group>
</div>
